module.exports = __webpack_public_path__ + "img/primarie-online-logo.8d0bfb3f.svg";